import React, { FC, useEffect } from 'react';
import { Button, Table, Divider, Modal } from 'antd';
import styles from './FindingTypeTemplate.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import FindingTypeTemplateForm from './FindingTypeTemplateForm';
import {
  fetchFindingTypeTemplates,
  FindingTypeTemplateType,
  showModal,
  deleteFindingTypeTemplate,
  getFindingTypeTemplate,
  setSelectedFindingTypeNames
} from './findingTypeTemplate.slice';
import { IconType } from '../../../shared/models/iconType.enum';
import SearchItem from '../../Shared/Landing/SearchForm/SearchItem';
import { SelectOption } from '../Annotation/annotation.types';
import { deleteOrDeprecate } from '../../../shared/Helpers';

type Props = {
  findingTypeTemplates: Array<FindingTypeTemplateType>;
  loading: boolean;
  onFindingTypeTemplateInit: (take: number, newPage: number) => void;
  onShowModal: (visible: boolean) => void;
  onDelete: (id: string) => void;
  getFindingTypeTemplate: (id: string) => void;
  findingTypeTemplateForUpdate: FindingTypeTemplateType;
  modalVisible: boolean;
  size: number;
  currentPage: number;
  totalNumber: number;
  onSetSelectedFindingTypeName: (name: string | undefined) => void;
  findingTypeNames: SelectOption[];
  selectedFindingTypeNames: string[];
};

const FindingTypeTemplateTable: FC<Props> = ({
  findingTypeTemplates,
  loading,
  onFindingTypeTemplateInit,
  onShowModal,
  onDelete,
  getFindingTypeTemplate,
  findingTypeTemplateForUpdate,
  modalVisible,
  size,
  currentPage,
  totalNumber,
  onSetSelectedFindingTypeName,
  findingTypeNames,
  selectedFindingTypeNames
}) => {
  useEffect(() => {
    onFindingTypeTemplateInit(size, 1);
  }, [onFindingTypeTemplateInit, size]);

  function onRowDelete(id: string, method: string) {
    Modal.confirm({
      title: 'Confirm',
      content: `Are you sure you want to ${method} Finding Type template?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        onDelete(id);
      }
    });
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Version',
      dataIndex: 'version',
      key: 'version'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      render: (value: any) => IconType[value]
    },
    {
      title: 'Color',
      key: 'color',
      dataIndex: 'color'
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <span>
          <a onClick={() => onUpdate(record.id)}>Update</a>
          <Divider type='vertical' />
          <a onClick={() => onRowDelete(record.id, deleteOrDeprecate(record.canDelete))}>{deleteOrDeprecate(record.canDelete)}</a>
        </span>
      )
    }
  ];

  const onAdd = () => {
    getFindingTypeTemplate('');
    onShowModal(true);
  };

  const onUpdate = (id: string) => {
    getFindingTypeTemplate(id);
    onShowModal(true);
  };

  return (
    <div className={styles.container}>
      <h1 className='mainheader'>Finding Type Templates</h1>
      {modalVisible ? <FindingTypeTemplateForm loading={loading} /> : ''}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SearchItem
          label='Finding type name'
          value={selectedFindingTypeNames.length ? selectedFindingTypeNames[0] : undefined}
          values={findingTypeNames}
          onChange={value => {
            onSetSelectedFindingTypeName(value);
            onFindingTypeTemplateInit(size, 1);
          }}
        />
        <Button className={styles.addFindingType} onClick={() => onAdd()}>
          Add Finding Type
        </Button>
      </div>
      <Table
        loading={loading}
        columns={columns}
        dataSource={findingTypeTemplates}
        rowKey='id'
        scroll={{ y: 500 }}
        pagination={{
          current: currentPage,
          total: totalNumber,
          pageSize: size,
          onChange: (page: number) => {
            onFindingTypeTemplateInit(size, page);
          },
          onShowSizeChange: (current: number, size: number) => {
            onFindingTypeTemplateInit(size, 1);
          }
        }}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  findingTypeTemplates: state.findingTypeTemplate.findingTypeTemplates,
  loading: state.findingTypeTemplate.loading,
  modalVisible: state.findingTypeTemplate.modalVisible,
  size: state.findingTypeTemplate.size,
  currentPage: state.findingTypeTemplate.currentPage,
  totalNumber: state.findingTypeTemplate.totalNumber,
  findingTypeNames: state.findingTypeTemplate.findingTypeNames,
  selectedFindingTypeNames: state.findingTypeTemplate.selectedFindingTypeNames
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onFindingTypeTemplateInit: (take: number, newPage: number) => dispatch(fetchFindingTypeTemplates(take, newPage)),
  getFindingTypeTemplate: (findingTypeTemplateId: string) => dispatch(getFindingTypeTemplate(findingTypeTemplateId)),
  onShowModal: (visible: boolean) => dispatch(showModal(visible)),
  onDelete: (id: string) => dispatch(deleteFindingTypeTemplate(id)),
  onSetSelectedFindingTypeName: (name: string | undefined) => dispatch(setSelectedFindingTypeNames(name))
});

export default connect(mapStateToProps, mapDispatchToProps)(FindingTypeTemplateTable);
